import merge from "merge";
import { components } from "./components";
import { typography } from "./typhography";
import { THEMES } from "../utils/constants";
import { themeColors } from "../theme/themeColors";
import { createTheme, responsiveFontSizes } from "@mui/material";

const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
  },
};

const themesOptions = {
  [THEMES.LIGHT]: {
    breakpoints,
    components: {
      ...components,
    },
    palette: {
      ...themeColors,
      background: {
        default: "#f0f0f0",
        paper: "#ffffff",
      },
      mode: "light",
    },
    typography,
  },
  [THEMES.DARK]: {
    breakpoints,
    components: {
      ...components,
      MuiCssBaseline: {
        styleOverrides: {
          "*": {
            boxSizing: "border-box",
            "&::-webkit-scrollbar": {
              width: 11,
            },
            "&::-webkit-scrollbar-track": {
              boxShadow: "inset 0 0 5px #e0e0e0",
              borderRadius: 10,
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#334254",
              borderRadius: 10,
              "&:hover": {
                background: "#38495c",
              },
            },
          },
          html: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            height: "100%",
            width: "100%",
          },
          body: {
            height: "100%",
          },
          a: {
            textDecoration: "none",
            color: "inherit",
          },
          "#root": {
            height: "100%",
          },
          "#nprogress .bar": {
            zIndex: "2000 !important",
          },
        },
      },
    },
    palette: {
      ...themeColors,
      background: {
        default: "#171c24",
        paper: "#222b36",
      },
      mode: "dark",
      text: {
        primary: "#ffffff",
        secondary: "#919eab",
      },
      grey: {
        50: "#ffffff",
        100: "#ffffff",
        200: "#ffffff",
        300: "#171c24",
        400: "#ffffff",
        main: "#ffffff",
        600: "#ffffff",
        700: "#ffffff",
        800: "#ffffff",
        dark: "#ffffff",
        light: "#ffffff",
      },
    },
    typography,
  },
};

type themeSettingsTypes = {
  theme: "LIGHT" | "DARK" | string;
  direction: "ltr" | "rtl" | string;
  roundedCorners?: boolean;
  responsiveFontSizes?: boolean;
};
export const gullTheme = (config: themeSettingsTypes) => {
  let themeOptions = themesOptions[config.theme];
  if (!themeOptions) {
    console.warn(new Error(`The theme ${config.theme} is not valid`));
    themeOptions = themesOptions[THEMES.LIGHT];
  }

  let theme = createTheme(
    merge(
      {},
      themeOptions,
      { ...(config.roundedCorners && { shape: { borderRadius: 16 } }) },
      { direction: config.direction }
    )
  );

  if (config.responsiveFontSizes) {
    theme = responsiveFontSizes(theme);
  }
  return theme;
};
